// 3rd party imports
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { inject } from 'mobx-react';

// bernie
import { AnalyticsStore, DialogRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// mobx
import { CaptchaStore, UserAuthStore } from 'stores';

// utils
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';
import { getUserAnalyticsMicroMessage } from '../../util/analytics';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkErrorSummary } from 'uitk-react-error-summary';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkText } from 'uitk-react-text';

export interface EmailProps {
  analytics?: AnalyticsStore;
  captcha?: CaptchaStore;
  email: string;
  l10n?: ILocalization;
  locale?: string;
  routeStore: RouteStore;
  sendVerificationEmail: (verificationEmail: string) => {};
  verificationEmailError?: string;
  userAuth?: UserAuthStore;
}

export const EmailDialog: React.FunctionComponent<EmailProps> = inject(
  'analytics',
  'userAuth',
)(({ analytics, email, l10n, routeStore, locale, sendVerificationEmail, verificationEmailError, userAuth }) => {
  const dialogId = 'email';
  const history = useHistory();

  React.useEffect(() => {
    history.push(`${routeStore.pathname}?${routeStore.mergeQueryString(routeStore.search, { pwaDialog: dialogId })}`);
  }, []);

  const onDismiss = () => {
    routeStore.closeDialog();
  };

  const resendVerificationEmail = () => {
    if (typeof analytics?.trackEvent === 'function') {
      analytics.trackEvent(
        'affhub_resend_verification_email.selected',
        'Affhub resend verification email selected',
        null,
        null,
        true,
        [getUserAnalyticsMicroMessage(userAuth?.currentUserDetails)],
      );
    }

    sendVerificationEmail(email);
  };

  const successMessage = l10n.formatText('signup.message.we_have_sent_an_email', email);

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogEmail" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            <UitkDialogContent>
              <UitkHeading tag="h3" size={5}>
                <LocalizedText message="signup.message.verification_email_sent" />
              </UitkHeading>
              {verificationEmailError && (
                <UitkSpacing margin={{ block: 'six' }}>
                  <div>
                    <UitkErrorSummary heading={verificationEmailError} />
                  </div>
                </UitkSpacing>
              )}
              <UitkText>{successMessage}</UitkText>
            </UitkDialogContent>

            <UitkDialogFooter
              key="UitkDialogFooter"
              stacked={false}
              buttonOne={{
                onClick: resendVerificationEmail,
                text: l10n.formatText('signup.dialog.resend_email'),
                type: 'tertiary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
});
